import React, { useState, useContext, useEffect } from "react";
import { Row, Col, FormGroup, Form } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../../context/UserContext";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
//import { Link } from 'react-router-dom';
import MaterialComponent from "../LearnerAssesment/MaterialComponent";
//import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import WhatsAppIcon from '@material-ui/icons/WhatsApp';
// import FacebookIcon from '@material-ui/icons/Facebook';
// import LinkedInIcon from '@material-ui/icons/LinkedIn';
// import TwitterIcon from '@material-ui/icons/Twitter';
// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: "100%",
//   },
//   selectEmpty: {
//     // marginTop: theme.spacing(1),
//   },
// }));

const Mygradesheet = () => {
 //const classes = useStyles();
  const context = useContext(UserContext);
  const [gradeSheetcourselist, setGradeSheetcourselist] = useState([]);
  const [course, setCourse] = useState("");
  const [scorecardpath, setScorecardpath] = useState(null);
 
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  // const [whatsappurl, setWhatsappurl] = useState("");
  // const [facebookurl, setFacebookurl] = useState("");
  // const [twitterurl, setTwitterurl] = useState("");
  // const [linkedinurl, setLinkedinurl] = useState("");

  useEffect(() => {
    // Update the document title using the browser API
    getcourselist();
  }, []);
  const getcourselist = async () => {
    axios
      .post("Certificate/gradeSheetcourselist")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
            setGradeSheetcourselist(res.data.gradeSheetcourselist);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

 
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    generateGradeSheet();
  };

  const generateGradeSheet = async () => {
    setLoading(true);
    if (course === null) {
      toast.error("Select Course");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("course", course);
   
      await axios
        .post("Certificate/generateGradeSheet", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            // setWhatsappurl(res.data.whatsappurl)
            // setFacebookurl(res.data.facebookurl)
            // setTwitterurl(res.data.twitterurl)
            // setLinkedinurl(res.data.linkedinurl)

            if(res.data.msg){
                toast.success(res.data.msg);
            }
            else{
                toast.error(res.data.errormsg);
                
            }

            if(res.data.scorecardpath){
                setScorecardpath(res.data.scorecardpath);
                setModalIsOpen(true)
            }
           
            // console.log("Saved Successfully");
            setLoading(false);
            
            // window.location.reload(true);
          } else {
            toast.error("Something went wrong");
          }
        }).catch((error) => {
          setLoading(false);
          let msg = "";
          if (error.response) {
            msg = "Something went wrong.";
          } else if (error.request) {
            msg = "Please try again.";
          } else {
            msg = "Un-expected error.";
          }
          toast.error(msg, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        });
    }
  };
  
  const closeModal = () => {
    setModalIsOpen(false)
  };


  //  const { rating } = setRating ;
  //     const { editrating } = setEditrating ;
  if (!context.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <section class="padding-default2">
        <div class="panel panel-primary card">
          <div class="panel-heading"> Generate Gradesheet</div>

          <div class="padding-pannele">
            <Form>
              <Row>
                <Col xs="12" sm="12" md="6">
                  <FormGroup row>
                    <Col lg={12}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel id="demo-simple-select-label">
                          Select Course{" "}
                        </InputLabel>
                         <Select
                          labelId="demo-simple-select-label"
                          name="skill"
                          id="skill"
                          onChange={(e) => setCourse(e.target.value)}
                        >
                          <MenuItem value="null">Select Course </MenuItem>
                          {gradeSheetcourselist.map((option) => (
                            <MenuItem value={option.courseid}>
                              {option.coursename}
                            </MenuItem>
                          ))}
                        </Select> 
                      </FormControl>
                    </Col>
                  </FormGroup>
                </Col>

              
              </Row>
        
              <div className="root">
                <div className="col-lg-12 text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={(e) => handleSubmit(e)}
                  >
                    Generate Gradesheet
                  </Button>

                  {loading === true ? (
                    <CircularProgress
                      size={24}
                      color="green"
                      className="buttonProgress1"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <br />
            </Form>
          </div>
        </div>
      </section>

      {modalIsOpen === true  ?(
 <Modal
 isOpen={modalIsOpen}
 onRequestClose={closeModal}
 size="lg"
 //class="custom-modal-style"
  style={{
    
     paddingBottom: "10%",

    height: "10%",
  }}
>
 <ModalHeader toggle={closeModal} className="header-modalc" > My Certificate </ModalHeader>
 <ModalBody>
 {/* <Row>
                  <Col xs="6" sm="12" md="12">
                      
<div  style={{float: "right"}}>
<a  href={whatsappurl} data-action="share/whatsapp/share" class="faicon whatsappicon "  target="_blank">
<WhatsAppIcon /> </a>

<a  href={facebookurl} class="faicon facebookicon"  rel="nofollow" target="_blank">
<FacebookIcon />
</a>

<a  href={twitterurl}  class="faicon twittericon"  rel="nofollow" target="_blank">
<TwitterIcon />
</a>

<a  href={linkedinurl}  class="faicon linkedinicon"  rel="nofollow" target="_blank">
<LinkedInIcon />
</a>

</div>

                  </Col>
                </Row><br/> */}
   <div  

  >
     <MaterialComponent
       contentType="contenttype"
       contentId="0"
       materialid="0"
       materialtype={scorecardpath?.split(".")?.pop()}
       materialpath={scorecardpath}
     />
   </div>
 </ModalBody>
 <ModalFooter></ModalFooter>
</Modal>
      ):("")}
     

    </div>
  );
};

export default Mygradesheet;
